import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var Backdrop =
/*#__PURE__*/
function (_Component) {
  _inherits(Backdrop, _Component);

  function Backdrop() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Backdrop);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Backdrop)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (e) {
      /* istanbul ignore else */
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      var _this$props = _this.props,
          isStatic = _this$props.isStatic,
          onCancel = _this$props.onCancel;

      if (!isStatic) {
        onCancel(e, null);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyPress", function (e) {
      var keyCode = e.keyCode;

      if (keyCode === 13) {
        _this.onCancel(e);
      }
    });

    return _this;
  }

  _createClass(Backdrop, [{
    key: "render",
    value: function render() {
      // remove warning for unused vars / missing proptype definition

      /* eslint no-unused-vars: 0, react/prop-types: 0 */
      var _this$props2 = this.props,
          isStatic = _this$props2.isStatic,
          onCancel = _this$props2.onCancel,
          rest = _objectWithoutProperties(_this$props2, ["isStatic", "onCancel"]);

      return React.createElement("div", _extends({}, rest, {
        onClick: this.onCancel,
        role: "button",
        tabIndex: -1,
        onKeyPress: this.onKeyPress
      }));
    }
  }]);

  return Backdrop;
}(Component);

Backdrop.propTypes = {
  isStatic: PropTypes.bool,
  onCancel: PropTypes.func,
  className: PropTypes.string
};
Backdrop.defaultProps = {
  className: 'tg-modal-backdrop',
  isStatic: false,
  onCancel: null
};
export default Backdrop;